import type { Theme } from '@mui/material';

export const styles = {
  buttonHelperModal: (theme: Theme) => ({
    button: {
      margin: 0,
    },

    '.button-help-modal-questionmark': {
      transform: 'translateY(2px)',
      color: theme.colors.primary[500],
    },
  }),
};
